import Section from "@components/Section";
import * as React from 'react';
export default {
  Section,
  React
};